import conniesFriendsLogo from '../images/conniesfriendslogo.png';

export default function Header() {
    return (
        <header style={{ display: 'flex', alignItems: 'start', marginTop: '8px', marginLeft: '24px', marginBottom: '8px' }}>
            <img src={conniesFriendsLogo} alt="Connie's Friends Logo" />
        </header>
    );
}
